import React from "react";

import { MultiSelectItem } from "../../../components/multi-select";
import { Team } from "../../../redux/slices";
import TeamItem from "./team-item";
import styles from "./teams.tab.module.scss";

export interface ConferenceTeamsProps {
  conference: string;
  teams: Team[];
  handleClickPlayCount: (item: MultiSelectItem) => void;
  playCountMap: Map<string, number>;
}

const ConferenceTeams = ({ conference, teams, handleClickPlayCount, playCountMap }: ConferenceTeamsProps) => {
  return (
    <div className={styles.conferenceItem}>
      <div className={styles.conferenceHeader}>
        <div className={styles.conferenceTitle}>{conference}</div>
      </div>
      <div>
        {teams.map((team) => {
          return (
            <TeamItem
              key={team.id}
              handleTeamClick={() => handleClickPlayCount({ id: team.id, label: team.name })}
              team={team}
              playCount={playCountMap.get(team.id) || playCountMap.get(team.team_id) || 0}
            />
          );
        })}
      </div>
    </div>
  );
};

export default ConferenceTeams;
